<template>
    <!-- This component is for product banners only -->
    <div>
        <div v-if="banner" :key="banner.id" class="flex-fill banner">
            <template v-if="banner.link != ''">
                <a :href="banner.link" :title="banner.name">
                    <div v-if="banner.short_content" class="featured-label p-1 p-xxl-2 py-2 text-center" :class="promoClass">
                        <div v-html="banner.short_content"></div>
                    </div>
                </a>
            </template>
            <template v-else>
                <div v-if="banner.short_content" class="featured-label p-1 p-xxl-2 py-2 text-center" :class="promoClass">
                    <div v-html="banner.short_content"></div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['banners', 'tyre', 'promoClass'],
        computed: {
            banner() {
                let vm = this;
                return this.banners.find(function(banner) {
                    return banner?.qualifying_products?.includes(vm.tyre.st_code);
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .banner {
        a {
            text-decoration: none;
        }
        .featured-label {
            border-radius: 4px;
            @media screen and (max-width: 1399px) {
                border-bottom-left-radius: 0 !important;
                border-bottom-right-radius: 0 !important;;
            }
        }
    }
</style>